import React from 'react';
import Banner from '../../../../../auxiliary-components/shared/Banner';
import FilesForDownload from '../../../../../auxiliary-components/shared/FilesForDownload';
import '../less/cashback.less';
import banner_img from '../img/banner_img.png';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ResultComponent from '../../../../Cards/views/orderAction/result.c';
import { Preloader } from 'MWComponents';

export default function template() {
    const isMobile = this.isViewportMobile(),
    page = 'cashback';
    const model = this.getModel(),
    { name, product, phone, email, info, company } = model.fields;

    function setSlideClasses(currentSlide, slidesList, transition) {
      const currentIndex = currentSlide.getAttribute('data-index');
        for (const item of slidesList) {
          const itemIndex = item.getAttribute('data-index');
          const indexDiff = currentIndex - itemIndex;
          const translate = indexDiff ? (240 * Math.pow(Math.abs(indexDiff), 1.431)) * (indexDiff/Math.abs(indexDiff)) : 0;
          if (transition) {
            item.style.transition = 'all 500ms';
          } else item.style.transition = 'unset';
          item.style.transform = `scale(${1 - Math.abs(indexDiff/14)}) translate(${translate}px)`;
          if (!indexDiff) {
            item.style.zIndex = 100;
          } else item.style.zIndex = -Math.abs(indexDiff);
        }
    }
    const beforeChange = (prev, next) => {
      if (!isMobile) {
        const currentSlideElement = this.sliderRef.current.innerSlider.list.querySelector(`[data-index="${next}"]`);
        const slidesList = this.sliderRef.current.innerSlider.list.querySelectorAll(`[data-index]`);
        if (prev === 0 && next === 7) {
          setSlideClasses(this.sliderRef.current.innerSlider.list.querySelector(`[data-index="${-1}"]`), slidesList, true);
          setTimeout(() => setSlideClasses(currentSlideElement, slidesList, false), 500);
        } else if (prev === 7 && next === 0) {
          setSlideClasses(this.sliderRef.current.innerSlider.list.querySelector(`[data-index="${8}"]`), slidesList, true);
          setTimeout(() => setSlideClasses(currentSlideElement, slidesList, false), 500);
        } else setSlideClasses(currentSlideElement, slidesList, true);
      }
    }

    const onInit = () => {
      if (!isMobile) {
        setTimeout(() => {
          if (this.sliderRef.current) {
            const currentSlide = this.sliderRef.current.innerSlider.list.querySelector(`.slick-current`);
            const slidesList = this.sliderRef.current.innerSlider.list.querySelectorAll(`[data-index]`);
            setSlideClasses(currentSlide, slidesList);
          }
        })
      }
    }

    const settings = {
      dots: false,
      infinite: true,
      speed: 500,
      autoplay: true,
      arrows: !isMobile,
      autoplaySpeed: 1000,
      slidesToShow: 1,
      slidesToScroll: 1,
      className: "center",
      centerMode: true,
      beforeChange,
      onInit,
      draggable: isMobile,
      variableWidth: true
    };
    let formScreen;
    switch (this.state.activeScreen) {
      case 'loader':
        formScreen = <Preloader/>
        break;
      case 'success':
        formScreen = <ResultComponent {...this.props} />
        break;
      default:
        formScreen = <div className='form-wrapper'>
        <div
            className='form-title'
            dangerouslySetInnerHTML={{
                __html: this.l10n('CASHBACK_FORM_TITLE')
            }}
        ></div>
        <div className='form-body'>
            <div className='form-body-item name'>
                <div className='form-sub-title' id='form-sub-title'>
                    {this.l10n('CASHBACK_FORM_NAME_TITLE')}
                </div>
                <div className='form-body-item'>
                    <input
                        name='name'
                        type='text'
                        className={`form-input name ${
                            !name.isValid && !name.firstInput ? 'red-color' : ''
                        }`}
                        onChange={this.handleChange}
                        placeholder={this.l10n(
                            'CASHBACK_FORM_NAME_PLACEHOLDER'
                        )}
                        onBlur={() => this.onBlurHandle('name')}
                    ></input>
                </div>
            </div>
            <div className='form-body-item'>
                <div className='form-sub-title'>
                    {this.l10n('CASHBACK_FORM_PHONE_TITLE')}
                </div>
                <input
                    name='phone'
                    type='text'
                    className={`form-input number ${
                        !phone.isValid && !phone.firstInput ? 'red-color' : ''
                    }`}
                    value={phone.value}
                    onChange={this.handleChange}
                    placeholder={this.l10n('CASHBACK_FORM_PHONE_PLACEHOLDER')}
                    onBlur={() => this.onBlurHandle('phone')}
                    onFocus={this.setPhone}
                    maxLength={20}
                    autoComplete='off'
                ></input>
            </div>
            <div className='form-body-item'>
                <div className='form-sub-title'>
                    {this.l10n('CASHBACK_FORM_EMAIL_TITLE')}
                </div>
                <input
                    name='email'
                    type='text'
                    className={`form-input email ${
                        !email.isValid && !email.firstInput ? 'red-color' : ''
                    }`}
                    onChange={this.handleChange}
                    placeholder={this.l10n('CASHBACK_FORM_EMAIL_PLACEHOLDER')}
                    onBlur={() => this.onBlurHandle('email')}
                ></input>
            </div>
            <div className='form-body-item'>
                <div className='form-sub-title'>
                    {this.l10n('CASHBACK_FORM_PRODUCT_NAME_TITLE')}
                </div>
                <input
                    name='product'
                    type='text'
                    className={`form-input product ${
                        !product.isValid && !product.firstInput
                            ? 'red-color'
                            : ''
                    }`}
                    onChange={this.handleChange}
                    placeholder={this.l10n('CASHBACK_PRODUCT_NAME_PLACEHOLDER')}
                    onBlur={() => this.onBlurHandle('product')}
                ></input>
            </div>
            <div className='form-body-item'>
                <div className='form-sub-title'>
                    {this.l10n('CASHBACK_FORM_COMPANY_NAME_TITLE')}
                </div>
                <input
                    name='company'
                    type='text'
                    className={`form-input company ${
                        !company.isValid && !company.firstInput
                            ? 'red-color'
                            : ''
                    }`}
                    onChange={this.handleChange}
                    placeholder={this.l10n(
                        'CASHBACK_FORM_COMPANY_NAME_PLACEHOLDER'
                    )}
                    onBlur={() => this.onBlurHandle('company')}
                ></input>
            </div>
            <div className='form-body-item'>
                <div className='form-sub-title'>
                    {this.l10n('CASHBACK_FORM_INFORMATION_TITLE')}
                </div>
                <textarea
                    name='info'
                    type='text'
                    className={`form-input info ${
                        !info.isValid && !info.firstInput ? 'red-color' : ''
                    }`}
                    onChange={this.handleChange}
                    placeholder={this.l10n(
                        'CASHBACK_FORM_INFORMATION_PLACEHOLDER'
                    )}
                    onBlur={() => this.onBlurHandle('info')}
                ></textarea>
            </div>
        </div>
        <button
            className='form-send-btn'
            disabled={!model.isValid}
            onClick={this.sendForm}
        >
            {this.l10n('CASHBACK_FORM_BTN_TITLE')}
        </button>
    </div>
        break;
    }
    const sliderContent = this.widgetsHelper.getWidget.call(this, 'partners').data ? this.filterSlidesByEnvironment(this.widgetsHelper.getWidget.call(this, 'partners').data.sort((a, b) => a.order - b.order)).map(item => {
      return (
        <div className='slider-item-wrapper' key={item.id}>
          <div className='slider-item '  style={{
            background: `url(${isMobile ? this.changeFilesUrl(item.img_mobile) : this.changeFilesUrl(item.img_desktop)}) center / contain no-repeat`, color: "blue"}}>
            <div className='slider-item-content'>
              <div className='slider-item-content-title' dangerouslySetInnerHTML={{ __html: item.title}}>
              </div>
              <div className='slider-item-content-text' dangerouslySetInnerHTML={{ __html: isMobile ? item.desc_mobile : item.desc_desktop}}>
              </div>
            </div>
          </div>
        </div>
      )
    }) : '';
    console.log(sliderContent)
    return (
        <div className='module-cashback'>
            <Banner
                img={banner_img}
                text={'CASHBACK_24_BANNER_SUBTITLE'}
                textMob={'CASHBACK_24_BANNER_SUBTITLE'}
                title={'CASHBACK_24_BANNER_TITLE'}
                page={page}
                isMobile={isMobile}
            ></Banner>
            <div className='cashback-content-wrapper'>
                <div className='content'>
                    <div className='how-to-block-wrapper'>
                        <div className='block-title'>{this.l10n('CASHBACK_HOW_TO_TITLE')}</div>
                        <div className='how-to-block'>
                            <div className='block-item'>
                                <div
                                    className='block-item-step'
                                    dangerouslySetInnerHTML={{
                                        __html: this.l10n('CASHBACK_HOW_TO_ITEM_TITLE_1')
                                    }}
                                ></div>
                                <div
                                    className='block-item-text'
                                    dangerouslySetInnerHTML={{
                                        __html: this.l10n('CASHBACK_HOW_TO_ITEM_TEXT_1')
                                    }}
                                ></div>
                            </div>
                            <div className='block-item'>
                                <div
                                    className='block-item-step'
                                    dangerouslySetInnerHTML={{
                                        __html: this.l10n('CASHBACK_HOW_TO_ITEM_TITLE_2')
                                    }}
                                ></div>
                                <div
                                    className='block-item-text'
                                    dangerouslySetInnerHTML={{
                                        __html: this.l10n('CASHBACK_HOW_TO_ITEM_TEXT_2')
                                    }}
                                ></div>
                            </div>
                            <div className='block-item'>
                                <div
                                    className='block-item-step'
                                    dangerouslySetInnerHTML={{
                                        __html: this.l10n('CASHBACK_HOW_TO_ITEM_TITLE_3')
                                    }}
                                ></div>
                                <div
                                    className='block-item-text'
                                    dangerouslySetInnerHTML={{
                                        __html: this.l10n(isMobile ? 'CASHBACK_HOW_TO_ITEM_TEXT_3_MOB' : 'CASHBACK_HOW_TO_ITEM_TEXT_3')
                                    }}
                                ></div>
                            </div>
                        </div>
                        <div
                            className='block-hint'
                            dangerouslySetInnerHTML={{
                                __html: this.l10n('CASHBACK_HOW_TO_ITEM_TEXT_HINT')
                            }}
                        ></div>
                    </div>
                </div>
                <div className='slider-wrapper'>
                    <div
                        className='form-title'
                        dangerouslySetInnerHTML={{
                            __html: this.l10n('CASHBACK_SLIDER_TITLE')
                        }}
                    ></div>
                  <Slider {...settings} ref={ref => (this.sliderRef.current = ref)}>
                    {sliderContent}
                  </Slider>
                </div>
                <div className='content'>
                    <div className='form-screen-wrapper'>{formScreen}</div>
                    <FilesForDownload
                        style={{marginBottom: 0}}
                        lang={this.props.lang}
                        widget={this.widgetsHelper.getWidget.call(this, 'files_to_download')}
                    />
                </div>
            </div>
        </div>
    );
}
